export const FACILITY_STATUSES = [
  {code: 'A', value: 'Active'},
  {code: 'I', value: 'Inactive'},
  {code: 'O-LT', value: 'Out Long Term'},
  {code: 'O-ST', value: 'Out Short Term'}
];
